import type { App } from 'vue'
import {
  CHAVE_OPERACOES_CATALOGO_EMPREGADOR,
} from '@next/modulos/estrutura-de-ponto-da-empresa/empregador/catalogo/apresentacao/catalogo-empregador.injecao'
import type {
  OperacoesCatalogoEmpregador,
} from '@next/modulos/estrutura-de-ponto-da-empresa/empregador/catalogo/catalogo-empregador.tipos'
import {
  criarCasoDeUsoListarOpcoesEmpregador,
} from '@next/modulos/estrutura-de-ponto-da-empresa/empregador/catalogo/listar-opcoes/listar-opcoes-empregador'
import {
  ListarOpcoesEmpregadorRepositorioHttp,
} from '@next/modulos/estrutura-de-ponto-da-empresa/empregador/catalogo/listar-opcoes/listar-opcoes-empregador.repositorio-http'

import type { InfraestruturaAplicacao } from '../criar-infraestrutura'

export const comporCatalogoEmpregador = (
  infraestrutura: InfraestruturaAplicacao,
): OperacoesCatalogoEmpregador => {
  const repositorio = new ListarOpcoesEmpregadorRepositorioHttp(
    infraestrutura.httpCondominio,
  )
  return {
    listarOpcoes: criarCasoDeUsoListarOpcoesEmpregador(repositorio.executar),
  }
}

export const instalarEmpregador = (
  app: App,
  infraestrutura: InfraestruturaAplicacao,
): void => {
  app.provide(
    CHAVE_OPERACOES_CATALOGO_EMPREGADOR,
    comporCatalogoEmpregador(infraestrutura),
  )
}
